<template>
	<transition v-if="prefetch" name="navigationmenu" @afterEnter="nextTransition('navigationmenu')">
		<div class="mobile-navigation" ref="mobileNavigationRoot" v-show="transitionTrigger.navigationmenu">
			<template v-if="!isNavigationInitialized">
				<ul class="breadcrumb">
					<li class="btn-close" @click="closeNavigation()"></li>

					<li class="breadcrumb-item">
						<i class="fa fa-home" aria-hidden="true"></i>
					</li>
				</ul>

				<loading-animation></loading-animation>
			</template>
			<div v-if="isNavigationInitialized && isDirty" class="mobile-navigation-inner">
				<div class="mobile-navigation-header">
					<transition name="blendIn">
						<ul class="breadcrumb d-block py-0" v-show="transitionTrigger.navigationmenuContent">
							<li class="btn-close" @click="closeNavigation()"></li>

							<li class="breadcrumb-item" @click="loadHome()">
								<i class="fa fa-home" aria-hidden="true"></i>
							</li>

							<li
								class="breadcrumb-item"
								v-for="breadcrumb in breadcrumbs"
								@click="slideTo(breadcrumb.parent, true)"
							>
								{{ breadcrumb.name }}
							</li>
						</ul>
					</transition>
				</div>

				<transition name="blendInSlideLeft">
					<div class="mobile-navigation-body" v-show="transitionTrigger.navigationmenuContent">
						<ul v-menu id="menu-1" class="mainmenu w-100 p-0 m-0 menu-active">
							<div class="menu-title">
								<span>Menu</span>
							</div>
							<li
								class="ddown"
								v-if="dataContainer1.parent"
								@click="slideTo((dataContainer1.parent && dataContainer1.parent.parent) || null, true)"
							>
								<span class="nav-direction btn-up">
									<i class="fa fa-lg fa-chevron-right" aria-hidden="true"></i>
								</span>
								<div class="nav-back">{{ $translate("Eros::Template.mobileNavBack") }}</div>
							</li>

							<li class="ddown" v-for="category in dataContainer1.categories">
								<a :href="getCategoryUrl(category.url)">{{ category.details[0].name }}</a>
								<span class="nav-direction" v-if="category.childCount" @click="slideTo(category)">
									<i class="fa fa-lg fa-chevron-right" aria-hidden="true"></i>
								</span>
							</li>
							<template v-if="dataContainer1.categories[0]">
								<li
									class="ddown"
									v-for="number in dataContainer1.categories[0].siblingCount -
									dataContainer1.categories.length"
								>
									<span
										class="nav-placeholder m-3"
										:style="{ width: Math.random() * 20 + 60 + '%' }"
									></span>
								</li>
							</template>
							<template v-else-if="dataContainer1.parent">
								<li class="ddown" v-for="number in dataContainer1.parent.childCount">
									<span
										class="nav-placeholder m-3"
										:style="{ width: Math.random() * 20 + 60 + '%' }"
									></span>
								</li>
							</template>
						</ul>

						<ul v-menu id="menu-2" class="mainmenu w-100 p-0 m-0">
							<div class="menu-title">
								<span>Menu</span>
							</div>
							<li
								class="ddown"
								v-if="dataContainer2.parent"
								@click="slideTo((dataContainer2.parent && dataContainer2.parent.parent) || null, true)"
							>
								<span class="nav-direction btn-up">
									<i class="fa fa-lg fa-chevron-right" aria-hidden="true"></i>
								</span>
								<div class="nav-back">{{ $translate("Eros::Template.mobileNavBack") }}</div>
							</li>

							<li class="ddown" v-for="category in dataContainer2.categories">
								<a :href="getCategoryUrl(category.url)">
									<template v-if="(typeof category.icon) !== 'undefined'">
										<img v-if="category.icon.includes('http')" alt="Daypack" :src="category.icon">
										<i v-else class="fa" :class="category.icon"></i>
									</template>
									{{ category.details[0].name }}
								</a>
								<span class="nav-direction" v-if="category.childCount" @click="slideTo(category)">
									<i class="fa fa-lg fa-chevron-right" aria-hidden="true"></i>
								</span>
							</li>
							<template v-if="dataContainer2.categories[0]">
								<li
									class="ddown"
									v-for="number in dataContainer2.categories[0].siblingCount -
									dataContainer2.categories.length"
								>
									<span
										class="nav-placeholder m-3"
										:style="{ width: Math.random() * 20 + 60 + '%' }"
									></span>
								</li>
							</template>
							<template v-else-if="dataContainer2.parent">
								<li class="ddown" v-for="number in dataContainer2.parent.childCount">
									<span
										class="nav-placeholder m-3"
										:style="{ width: Math.random() * 20 + 60 + '%' }"
									></span>
								</li>
							</template>
						</ul>
					</div>
				</transition>
				<transition name="blendIn">
					<div
						class="mobile-navigation-footer position-fixed fixed-bottom"
						v-show="transitionTrigger.navigationmenuContent && footerCategories.length > 0"
					>
						<ul class="list-inline landingpage-list">
							<li
								class="ddown navSpecial"
								v-if="specialNavigation.title != '' && specialNavigation.childCount >= 1"
							>
								<a href="#" @touchstart.stop @click="slideTo(specialNavigation, false, true)"
								><i class="fas fa-book"></i> {{ specialNavigation.title }}</a>
							</li>
							<li
								class="ddown"
								v-for="(category, index) in footerCategories"
								v-show="!category.hideCategory"
							>
								<a
									:href="category.details[0].nameUrl"
									@touchstart.stop
									v-if="category.showChildren || category.details[0]"
								>
									{{
									index === 1
									? $translate("Eros::Template.altPromiseTitle")
									: category.details[0].name
									}}
								</a>
							</li>
						</ul>
						<div
							class="navi-footer-payment-icons"
							v-if="
								Object.keys(footerIcons.payment).length + Object.keys(footerIcons.shipping).length > 0
							"
							ref="naviFooterPaymentIcons"
						>
							<a
								:href="shippingLink"
								:title="$translate('Eros::Template.paymentsAndShipping')"
								:alt="$translate('Eros::Template.paymentsAndShipping')"
								class="services-link"
							>
								<div class="services-payment">
									<lazy-img
										v-for="(paymentMethod, index) in footerIcons.payment"
										picture-class="payment-method"
										:image-url="pluginPath + paymentMethod.image + '.png'"
										:alt="paymentMethod.alt"
										:title="paymentMethod.title"
										:key="`payment-mehod-${index}`"
									>
									</lazy-img>
									<lazy-img
										v-for="(shippingMethod, index) in footerIcons.shipping"
										picture-class="shipping-method"
										:image-url="pluginPath + shippingMethod.image + '.png'"
										:alt="shippingMethod.alt"
										:title="shippingMethod.title"
										:key="`shipping-mehod-${index}`"
									>
									</lazy-img>
								</div>
							</a>
						</div>
					</div>
				</transition>
			</div>
		</div>
	</transition>
</template>

<script>
import { mapState } from "vuex";
import { MediaQueryHelper } from "../../../ceres/helper/MediaQueryHelper";
import { isNullOrUndefined, isDefined } from "../../../ceres/helper/utils";
import { PrefetchMixin } from "../../mixins/prefetch.js";

export default {
	props: {
		template: {
			default: "#vue-mobile-navigation",
			type: String
		},
		initialCategory: Object,
		breakpoints: {
			type: Array,
			default: () => ["xs", "sm", "md"]
		},
		includeLanguage: Boolean,
		pluginPath: {
			type: String,
			required: true
		},
		footerIcons: {
			type: Object,
			default: () => {
			}
		},
		footerCategories: {
			type: Array,
			default: () => []
		},
		shippingLink: {
			type: String,
			required: true
		}
	},

	mixins: [
		PrefetchMixin
	],

	data() {
		return {
			dataContainer1: {
				parent: {},
				categories: []
			},
			dataContainer2: {
				parent: {},
				categories: []
			},
			useFirstContainer: false,
			isNavigationInitialized: false,
			selectedCategory: null,
			specialNavigation: {},
			transitionTrigger: {
				navigationmenu: false,
				navigationmenuContent: false
			},
			isDirty: false
		};
	},

	computed: {
		breadcrumbs() {
			const breadcrumbs = [];
			let container = this.useFirstContainer ? this.dataContainer2 : this.dataContainer1;

			if (this.useFirstContainer && typeof this.dataContainer2.categories[0]?.icon !== "undefined") {
				breadcrumbs.unshift({
					name: this.specialNavigation.title,
					parent: this.specialNavigation
				});
			} else {
				while (container && container.parent && Object.keys(container.parent).length) {
					breadcrumbs.unshift({
						name: container.parent.details[0].name,
						parent: container.parent || null
					});

					container = container.parent;
				}
			}

			return breadcrumbs;
		},

		...mapState({
			navigationTree: (state) => state.navigation.tree
		})
	},

	created() {
		this.$store.commit("setCurrentCategory", this.initialCategory);

		if (!isNullOrUndefined(App.Eros.Config.header.specialNavigationObject)) {
			const specialNavigation = structuredClone(App.Eros.Config.header.specialNavigationObject);

			if (
				App.Eros.Config.header.specialNavigationObject &&
				Array.isArray(App.Eros.Config.header.specialNavigationObject.columns)
			) {
				specialNavigation.columns = undefined;
				if (!specialNavigation.hasOwnProperty("children")) {
					specialNavigation.children = [];
				}

				App.Eros.Config.header.specialNavigationObject.columns.forEach(col => {
					if (Array.isArray(col.children)) {
						specialNavigation.children.push(...col.children);
					}
				});

				specialNavigation.childCount = specialNavigation.children.length;
				specialNavigation.children.forEach(child => {
					child.siblingCount = specialNavigation.childCount;
				});
			}

			this.specialNavigation = specialNavigation;
		}
	},

	beforeMount() {
		if (App.Eros.Config.general.benchmarkJS) console.time("App.eros.components.pageDesign.MobileNavigation: mount"); // eslint-disable-line no-console
	},

	mounted() {
		if (App.Eros.Config.general.benchmarkJS) console.timeEnd("App.eros.components.pageDesign.MobileNavigation: mount"); // eslint-disable-line no-console

		if (this.prefetch) {
			this.initializeEventlistener();
		} else {
			vueEventHub.$on("prefetch", () => {
				this.initializeEventlistener();
			});
		}
	},

	methods: {
		initializeEventlistener() {
			vueEventHub.$on("open-mobile-navigation", () => this.openNavigation());
			this.addEventListener();
		},
		addEventListener() {
			const QueryHelper = new MediaQueryHelper();
			const breakpoint = QueryHelper.getCurrentBreakpoint();

			QueryHelper.addFunction(this.loadInitialTree, this.breakpoints);

			if (this.breakpoints.includes(breakpoint)) {
				this.loadInitialTree();
			}
		},

		loadInitialTree() {
			if (this.navigationTree.length <= 0) {
				const categoryId = this.initialCategory && this.initialCategory.id ? this.initialCategory.id : null;

				this.$store.dispatch("loadPartialNavigationTree", categoryId).then((response) => {
					this.$store.commit("setNavigationTree", response);
					this.initNavigation();
				});
			}
		},

		initNavigation() {
			if (this.initialCategory && this.initialCategory.id) {
				if (this.initialCategory.linklist === "N") {
					this.$store.commit("setCurrentCategory", this.initialCategory);
				} else {
					this.$store.dispatch("setCurrentCategoryById", {
						categoryId: parseInt(this.initialCategory.id)
					});
					this.initialSlide(this.$store.state.navigation.currentCategory);
				}
			}

			this.dataContainer1.parent = null;
			this.dataContainer1.categories = this.navigationTree;
			this.isNavigationInitialized = true;
		},

		initialSlide(currentCategory) {
			if (currentCategory) {
				if (currentCategory.children) {
					this.slideTo(currentCategory);
				} else if (currentCategory.parent) {
					this.slideTo(currentCategory.parent);
				}
			}
		},

		slideTo(category, back, forceFirstLevel = false) {
			if (forceFirstLevel && this.selectedCategory !== category && this.useFirstContainer) {
				this.slideTo((this.dataContainer1.parent && this.dataContainer1.parent.parent) || null, true);
				return setTimeout(() => this.slideTo(category, back), 250);
			}

			const children = isDefined(category) ? category.children : this.navigationTree;
			const categoryId = isDefined(category) ? category.id : null;

			if (this.selectedCategory !== category) {
				this.loadPartialTree(categoryId);
				this.selectedCategory = category;

				if (this.useFirstContainer) {
					this.dataContainer1.parent = category;
					this.dataContainer1.categories = children || [];

					$("#menu-2").trigger("menu-deactivated", { back: !!back });
					$("#menu-1").trigger("menu-activated", { back: !!back });
				} else {
					this.dataContainer2.parent = category;
					this.dataContainer2.categories = children || [];

					$("#menu-1").trigger("menu-deactivated", { back: !!back });
					$("#menu-2").trigger("menu-activated", { back: !!back });
				}

				this.useFirstContainer = !this.useFirstContainer;
			}
		},

		loadPartialTree(categoryId) {
			// eslint-disable-next-line eqeqeq
			if (
				this.selectedCategory != categoryId ||
				(isDefined(this.selectedCategory) && this.selectedCategory.id !== categoryId)
			) {
				this.$store.dispatch("loadPartialNavigationTree", categoryId).then((response) => {
					if (
						(isNullOrUndefined(this.selectedCategory) && isNullOrUndefined(categoryId)) ||
						(isDefined(this.selectedCategory) && this.selectedCategory.id === categoryId)
					) {
						this.$store.commit("setNavigationTree", response);
						this.updateDataContainers(categoryId);
					}
				});
			}
		},

		updateDataContainers(categoryId) {
			const containers = ["dataContainer1", "dataContainer2"];
			const category = this.getCategoryById(categoryId, this.navigationTree);

			for (const container of containers) {
				if (category) {
					this[container].parent = category;
					this[container].categories = category.children;
				} else {
					// root level
					this[container].parent = null;
					this[container].categories = this.navigationTree;
				}
			}
		},

		getCategoryById(categoryId, tree) {
			for (const cat of tree) {
				if (categoryId === cat.id) {
					return cat;
				} else if (cat.children) {
					const foundCat = this.getCategoryById(categoryId, cat.children);

					if (foundCat) {
						return foundCat;
					}
				}
			}

			return null;
		},

		closeNavigation() {
			this.transitionTrigger.navigationmenu = false;
			this.transitionTrigger.navigationmenuContent = false;

			document.querySelector(".mobile-navigation").classList.remove("open");
			document.querySelector("body").classList.remove("menu-is-visible");
		},

		getCategoryUrl(url) {
			const trailingSlash = url[0] === "/" ? "" : "/";
			const prefix = this.includeLanguage ? `/${App.language}${trailingSlash}` : "";

			return prefix + url;
		},

		openNavigation() {
			this.isDirty = true;
			document.querySelector(".mobile-navigation").style.willChange = "transform";

			this.transitionTrigger.navigationmenu = true;

			document.querySelector(".mobile-navigation").classList.add("open");
			setTimeout(() => {
				document.querySelector("body").classList.add("menu-is-visible");
			}, 90);
		},

		nextTransition(lastStep = "") {
			if (lastStep === "navigationmenu") {
				document.querySelector(".mobile-navigation").style.willChange = "";
				this.transitionTrigger.navigationmenuContent = true;
			}
		},

		loadHome() {
			return (document.location.href = App?.urls?.home ?? "/");
		}
	},

	directives: {
		menu: {
			bind(el) {
				// add "activated" classes when menu is activated
				$(el).on("menu-activated", (event, params) => {
					$(event.target).addClass("menu-active");
					$(event.target).addClass(params.back ? "animate-in-from-left" : "animate-in-from-right");
				});
				// add "deactivated" classes when menu is deactivated
				$(el).on("menu-deactivated", (event, params) => {
					$(event.target).removeClass("menu-active");
					$(event.target).addClass(params.back ? "animate-out-to-right" : "animate-out-to-left");
				});
				// this removes the animation class automatically after the animation has completed
				$(el).on("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd", () => {
					$(".mainmenu").removeClass((index, className) => {
						return (className.match(/(^|\s)animate-\S+/g) || []).join(" ");
					});
				});
			}
		}
	}
};
</script>